import {AppPermissions, MailInStatus} from "@app/core-shared";

export const mailInStatusTypeEnumOptions: {
  label: string,
  value: MailInStatus,
  permissions?: AppPermissions[]
}[] = [
  {
    label: 'core-portal.settings.mail-in-status.0',
    value: MailInStatus.Processing
  },
  {
    label: 'core-portal.settings.mail-in-status.1',
    value: MailInStatus.Failed
  },
  {
    label: 'core-portal.settings.mail-in-status.2',
    value: MailInStatus.Success
  }
];
